<template>
  <v-app data-app>
    <v-content>
      <v-col cols="12" offset-sm="0" md="10" offset-md="1" xl="6" offset-xl="3">
        <v-stepper v-model="step" vertical>
          <v-stepper-step :complete="step > 2" step="1" color="accent">
            <span class="step-title uppercase">
                {{$t('userRegistrationSteps.stepper.firstStep.title')}}
                <span class="primary-color">{{ $t(`userRegistrationSteps.form.${this.user.role}`)  }}</span>
            </span>
          </v-stepper-step>

          <v-stepper-step :complete="step > 2" step="2" color="accent">
            <span class="step-title uppercase">
              {{$t('userRegistrationSteps.stepper.secondStep.title')}}
              <v-icon v-if="step > 2" color="primary" @click="goToStep(2)">mdi-pencil</v-icon>
            </span>
          </v-stepper-step>

          <second-step
              @submitForm="submitForm"
              @goToNextStep="goToNextStep"
              :user="user"
              :settings="settings"
              :customer-type="customerType"
          />
        </v-stepper>
      </v-col>
    </v-content>
  </v-app>
</template>

<script>
// import FirstStep from './steps/FirstStep';
import SecondStep from './steps/SecondStep';
import ThirdStep from './steps/ThirdStep';
import api from '../../api/index';

export default {
  components: { SecondStep },
  data() {
    return {
      // user is vendor if role !== client
      user: {
        role: 'designer',
        firstname: '',
        lastname: '',
        phone_number: '',
        email: '',
        description: '',
        number_detailist: '',
        social_insta:'',
        main_category:'',
        url: '',
        termsAndConditions: false,
        receiveLatestNews: false,
        addressAttributes: {
          firstname: '',
          lastname: '',
          company: '',
          address1: '',
          city: '',
          zipcode: '',
          countryId: '',
          stateId: '',
          phone: '',
        },
      },
      step: 2,
      roles: [
        {
          value: 'designer',
          img: '/images/icons/designers.svg',
          subtitle: this.$t('userRegistrationSteps.form.designerDescription'),
        },
        {
          value: 'client',
          img: '/images/icons/cart.svg',
          subtitle: this.$t('userRegistrationSteps.form.clientDescription'),
        },
      ],
      settings: {
        formSubmitting: false,
      },
    };
  },
  methods: {
    submitForm() {
      this.settings.formSubmitting = true;

      if (this.user.role === 'client') {
        api.post('user/spree_user', { spreeUser: this.user }).then(() => {
          window.location.href = 'products';
        });
      } else {
        api.post('api/v1/vendors', { vendor: this.user })
            .then((e) => {
              if (this.user.role === 'designer') {
                window.location.href = 'designers-registration-thanks';
              } else {
                window.location.href = 'corporates-registration-thanks';
              }
            })
            .catch((e) => {
              this.settings.formSubmitting = false;
              console.log('Cannot to create an account');
              alert(this.$t('userRegistrationSteps.form.cannotCreateAccount'));
            });
      }
    },
    goToStep(step) {
      this.step = step;
    },
    goToNextStep() {
      this.step++;
    },
    goBack() {
      this.step--;
    },

    async setDiscountCodeFromQueryParams() {
      if (this.queryParams && this.queryParams.length) {
        this.queryParams.forEach(queryParam => {
          if (queryParam[0] === "discount_code") {
            this.checkDiscountCode(queryParam[1]);
          }
        });
      }
    },
  },

  computed: {
    queryParams() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      return Object.entries(Object.fromEntries(urlSearchParams.entries()));
    },

    customerType() {
      if (this.queryParams && this.queryParams.length) {
        this.queryParams.forEach(queryParam => {
          if (queryParam[0] === "user_type") {
            console.log(queryParam[1])
            this.user.role = queryParam[1];
            return queryParam[1];
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.v-application {
  font-family: 'Lato', sans-serif !important;
  background: #f8f8f8 !important;
}

.v-btn:focus {
  outline: none;
}

.v-input__slot {
  min-height: 30px !important;
  border: 1px solid #707070;
  box-shadow: 0 0 0 black !important;
}
.v-text-field--outlined .v-label {
  //top: 14px !important;
}
form div.container.container--fluid div.row div.col.col-12 div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot{
  border:0px;
}
.theme--light div.v-subheader.theme--light{
  padding:0px;
  font-weight: bold;
  color: #534f50;
}
.theme--light.v-text-field--outlined fieldset {
  border-radius: 4px !important;
  border: solid 1px #534f50 !important;
}

.step-title {
  color: #534F50;
  text-shadow: none;
}

.theme--light.v-label {
  color: rgba(83, 79, 80, 0.5) !important;
}
.colored_labels{
  color: #e60f73 !important;
  padding:4px 0px;
  font-weight: bold;
}
.v-btn--outlined {
  border-width: 2px !important;
}
</style>
